



































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import LoadingIndicator from '@/components/LoadingIndicator'
import TransferCampaignListingsTrigger from './TransferCampaignListingsTrigger.coffee'

settings =
  name: 'TransferCampaignListingsTriggerModal'

  resources:
    targets:
      resourceName: 'campaign'
      slug: 'campaigns/:campaignId/targets'
      fetch: false

  vue:
    props: ['resourceComponent', 'resourceKey']
    components: { Modal, RequestButton, LoadingIndicator }
    mixins: [TransferCampaignListingsTrigger.trigger()]

    computed:
      modalConfig: -> @modal.config || {}
      campaign: -> @modalConfig.campaign

export default VueOptions.vue settings
